import { useContext, useState } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import UserContext from "src/provider/state-manager/userProvider"
import { BiCheck } from "react-icons/bi"
import { AppLabel, AppSpan, AppText, Button, CustomContainer, FlexRow, OrderedList, RemeberMeContainer } from "src/style"
import helpers from "src/utils/helpers"
import { AppCenterPopupD3, CenterPopupHeaderD3, Portal } from "src/component"

export const LimitUpgradeIndemnityD3: React.FC<any> = ({nuban, next, back, close}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {accountWithBalanceDetails}} = useContext(UserContext)
    const [isAgree, setIsAgree] = useState(false)

    const accountName = helpers.getAccountDetailsByParam(accountWithBalanceDetails, 'nuban', nuban)?.name

    return (
        <Portal forcePortal>
            <AppCenterPopupD3 height='83' zIndex='6' overflow='hidden' close={close}>
                <CenterPopupHeaderD3 title='Indemnity Form' close={back} />
                <CustomContainer 
                    height="83"
                    style={{maxHeight: '91%'}}
                    className="popup-content-container"
                >
                    <CustomContainer topMargin='2.5'>
                        <CustomContainer 
                            radius='0.8' borderColor='#E7F6F5' bgColor='#E7F6F5'
                            padding='2' topPadding='1.5'
                        >
                            <AppLabel textSize='1.3' fontWeight='700' color='#0A756F'>Indemnity Form for Limit Upgrade</AppLabel>
                            {/* <>
                                <AppText textSize='1.3' color='#0A756F' bottomPadding='1' >
                                    I, {accountName}, hereby acknowledge and agree to the following terms and conditions for the upgrade of transaction limits on my account: 
                                </AppText>
                                <OrderedList 
                                    topMargin="0.5" leftMargin="2" color="#0A756F"
                                    markerSize="1.2" markerWeight='600'
                                >
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I understand that this upgrade is voluntary and is being done at my request.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I confirm that all the information provided by me for this upgrade is accurate and complete.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >Acknowledged and understand that the upgraded transaction limits are subject to the terms and conditions of the app and the institution.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I agree that any transaction made within the upgraded limit shall be my sole responsibility, and I will not hold {institutionData?.name} liable for any losses or damages arising from such transactions.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I undertake to follow all security measures and guidelines provided by {institutionData?.name} to ensure the safety and security of my transactions.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I understand that {institutionData?.name} has the right to modify or revoke this upgraded limit at any time without prior notice.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I hereby release and discharge {institutionData?.name} and its employees from any and all liability arising from or related to the upgrade of my transaction limits.</AppText></li>
                                    <li><AppText textSize='1.3' color='#0A756F' bottomPadding='0.7' >I agree to indemnify and hold harmless the {institutionData?.name} and its employees from any claims, losses, or damages resulting from my use of the upgraded transaction limits.</AppText></li>
                                </OrderedList>
                            </> */}
                            <AppText textSize='1.3' color='#0A756F' bottomPadding='0.7'>
                                {institutionData?.accountLimitIdemity}
                            </AppText>
                        </CustomContainer>
                        <FlexRow width='auto' sizeUnit='' justifyContent='flex-start' topMargin="1" alignItems="flex-start">
                            <RemeberMeContainer 
                                className={`remember-checkbox ${isAgree && 'isremember-me'}`}
                                style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0', marginTop: '0.5rem'}}
                                onClick={() => setIsAgree(!isAgree)}
                            >
                                {isAgree ? <AppSpan color='#0D968F' textSize='1.5' topMargin='-0.3'><BiCheck className='checkbox-icon' /></AppSpan> : null}
                            </RemeberMeContainer>
                            <AppText leftPadding='1'>I confirm that I have read, understood, and agreed to the terms and conditions of this indemnity form</AppText>
                        </FlexRow>
                        
                        <CustomContainer topMargin='2.5'>
                            <Button 
                                width='100' sizeUnit="%" height='4.4' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                                className='app-action-btn'
                                disabled={!isAgree}
                                onClick={next}
                            >
                                Continue
                            </Button>
                        </CustomContainer>
                    </CustomContainer>
                </CustomContainer>
            </AppCenterPopupD3>
        </Portal>
    )
}